import React, { Component } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import WaveLoading from 'react-loadingg/lib/WaveLoading';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

export default class Price extends Component {
    constructor() {
        super()
        this.state = {
            data: [],
            next: null,
            prev: null,
            loading: true,

            google_map_api_key: '',
            notification_auth_key: '',
            web_app_id: '',
            mobile_app_id: '',
            sms_sid: '',
            sms_token: '',
            sms_service_id: '',
            template_logo: '',
            email_token: '',
            mobile_number_1: "",
            mobile_number_2: "",
            mobile_number_3: "",
            emergency: "",
        }
    }

    loading = (args) => {
        this.setState({
            loading: args
        })
    }

    componentDidMount() {
        this.fetchAllData()
    }

    next = () => {
        this.loading(true)
        axios.get(
            this.state.next.replace(/^http:\/\//i, 'https://'),
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false,

            })
        })
            .catch(error => {
                NotificationManager.error('Error : ', error, 3000);
            })
    }

    prev = () => {
        this.loading(true)
        axios.get(
            this.state.prev.replace(/^http:\/\//i, 'https://'),
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false,
            })
        })
            .catch(error => {
                NotificationManager.error('Error : ', error, 3000);
            })
    }

    fetchAllData() {
        this.loading(true)
        axios.get(
            Base.url + 'Configurations/',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            console.log('Response all :', response.data.results);
            // console.log('Response all :', response.data.results[0].price);
            // console.log('Response all :', response.data.results[1].price);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false,

                notification_auth_key: response.data.results[0].param_value,
                web_app_id: response.data.results[1].param_value,
                mobile_app_id: response.data.results[7].param_value,
                sms_sid: response.data.results[2].param_value,
                sms_token: response.data.results[3].param_value,
                sms_service_id: response.data.results[4].param_value,
                template_logo: response.data.results[5].param_value,
                email_token: response.data.results[6].param_value,
                google_map_api_key: response.data.results[8].param_value,
                mobile_number_1: response.data.results[10].param_value,
                mobile_number_2: response.data.results[11].param_value,
                mobile_number_3: response.data.results[12].param_value,
                emergency: response.data.results[9].param_value,

            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    updateVal = (name, value) => {

        // console.log('State :',this.state);
        console.log('Update name :',name);

        console.log('Update value :',value);
        // return false
        // this.loading(true)

        if (name == 'emergency') {
            var bodyFormData1 = new FormData();
            bodyFormData1.set('param_name', '24/7_Customer_Service');
            bodyFormData1.set('new_param_value', value);
        } else {
            var bodyFormData1 = new FormData();
            bodyFormData1.set('param_name', name);
            bodyFormData1.set('new_param_value', value);
        }

        // bodyFormData1.set('new_param_value', this.state[e.target.name]);
        // return



        axios.put(
            Base.url + 'Configurations/',
            bodyFormData1,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
            .then(response => {
                // console.log('response : ',response);
                if (response.data.Status) {
                    NotificationManager.success(response.data.Message, 'Success : ', 3000)
                    this.fetchAllData()
                    this.loading(false)
                } else {
                    console.log(response);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    update = (e) => {

        // console.log('Update name :'c);

        // console.log('Update value :',this.state[e.target.name]);
        // return false
        let name = e.target.name
        let value = this.state[e.target.name]

        console.log('Update name :', name);

        console.log('Update value :', value);

        confirmAlert({
            title: 'Are you sure ',
            message: 'You want to change ' + e.target.id,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.updateVal(name, value)
                },
                {
                    label: 'No',
                    onClick: () => { return false }
                }
            ]
        });
    }

    render() {
        return (
            <div>
                {/* <NotificationContainer/> */}

                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Settings" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            <div className="col-xl-12 mb-5 mb-xl-0">
                                <div className="card shadow">
                                    <div className="card-header border-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h3 className="mb-0">Settings</h3>
                                            </div>
                                            <div className="col text-right">
                                                {/* <button href="#!" className="btn btn-sm btn-primary" onClick={this.update}>Update</button> */}
                                                {/* <button href="#!" className="btn btn-sm btn-primary" onClick={this.updateCharges}>Update all</button> */}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.loading ? <WaveLoading /> :
                                        <div className="table-responsive">
                                            {/* Projects table */}
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">Keyword</th>
                                                        <th scope="col">Price</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr>
                                                        <th scope="row">Notification Key</th>
                                                        <td>
                                                            <input className="form-control" name={'notification_auth_key'} onChange={this.onChange} value={this.state.notification_auth_key} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="Notification Key" name={'notification_auth_key'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Google Map API Key</th>
                                                        <td>
                                                            <input className="form-control" name={'google_map_api_key'} onChange={this.onChange} value={this.state.google_map_api_key} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="Notification Key" name={'google_map_api_key'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Web Notification Key</th>
                                                        <td>
                                                            <input className="form-control" name={'web_app_id'} onChange={this.onChange} value={this.state.web_app_id} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="Web Notification Key" name={'web_app_id'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>




                                                    <tr>
                                                        <th scope="row">App Notification Key</th>
                                                        <td>
                                                            <input className="form-control" name={'mobile_app_id'} onChange={this.onChange} value={this.state.mobile_app_id} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="App Notification Key" name={'mobile_app_id'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">SMS SID Key</th>
                                                        <td>
                                                            <input className="form-control" name={'sms_sid'} onChange={this.onChange} value={this.state.sms_sid} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="SMS SID Key" name={'sms_sid'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">SMS Token</th>
                                                        <td>
                                                            <input className="form-control" name={'sms_token'} onChange={this.onChange} value={this.state.sms_token} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="SMS Token" name={'sms_token'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">SMS Service Id</th>
                                                        <td>
                                                            <input className="form-control" name={'sms_service_id'} onChange={this.onChange} value={this.state.sms_service_id} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="SMS Service Id" name={'sms_service_id'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Sendgrid Email service key</th>
                                                        <td>
                                                            <input className="form-control" name={'email_token'} onChange={this.onChange} value={this.state.email_token} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="Sendgrid Email service key" name={'email_token'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Pdf Logo url</th>
                                                        <td>
                                                            <input className="form-control" name={'template_logo'} onChange={this.onChange} value={this.state.template_logo} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="Pdf Logo url" name={'template_logo'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">24/7 Customer care </th>
                                                        <td>
                                                            <input className="form-control" name={'emergency'} onChange={this.onChange} value={this.state.emergency} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="24/7 Customer care" name={'emergency'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Mobile Number 1</th>
                                                        <td>
                                                            <input className="form-control" name={'mobile_number_1'} onChange={this.onChange} value={this.state.mobile_number_1} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="mobile number 1" name={'mobile_number_1'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Mobile Number 2</th>
                                                        <td>
                                                            <input className="form-control" name={'mobile_number_2'} onChange={this.onChange} value={this.state.mobile_number_2} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="mobile number 2" name={'mobile_number_2'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Mobile Number 3</th>
                                                        <td>
                                                            <input className="form-control" name={'mobile_number_3'} onChange={this.onChange} value={this.state.mobile_number_3} type="text" />
                                                        </td>
                                                        <td>
                                                            <button href="#!" className="btn btn-sm btn-primary" id="mobile number 3" name={'mobile_number_3'} onClick={this.update}>Update</button>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        )
    }
}
